export const generalErrorTitle = "Oops";
export const generalErrorText =
  "Etwas ist schief gelaufen. Probiere es später noch einmal oder kontaktiere uns, wenn das Problem weiterhin besteht.";
